import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MdLock, MdArrowForward } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import _ from 'lodash';
import { CircularProgress } from '@material-ui/core';
import AgencyLogoWithAttribution from '../AgencyLogoWithAttribution';
import Topbar from '../Header/Topbar';
import TravelWitsLogo from '../../assets/svgs/travelwitsLogo.svg';
import { verifyPagePasswordRequest } from '../../store/slices/user';
import { SearchStatus } from '../../constants';
import MarkdownToHtml from '../MarkdownToHtml';
import LoginButton from '../Header/Navbar/LoginButton';

const PasswordScreen = ({ setDoShowPasswordScreen, doShowPasswordScreen }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const {
    travelAgency, pagePasswordError, isPagePasswordVerified, pagePasswordRequestState,
  } = useSelector((store) => store.user);
  const passwordScreenHeading = travelAgency && travelAgency.settings
  && travelAgency.settings.passwordScreenHeading;
  const doShowAgentLoginOnPasswordScreen = !!travelAgency
    ?.settings?.doShowAgentLoginOnPasswordScreen;

  const passwordScreenDescription = travelAgency && travelAgency.settings
  && travelAgency.settings.passwordScreenDescription;
  const passwordScreenInputPlaceHolder = travelAgency?.settings?.passwordScreenInputPlaceHolder || 'Enter password';

  useEffect(() => {
    if (password && isPagePasswordVerified) {
      track('handlePasswordVerifed');
      setDoShowPasswordScreen(!doShowPasswordScreen);
    }
  }, [doShowPasswordScreen, isPagePasswordVerified,
    password, setDoShowPasswordScreen, track]);

  useEffect(() => {
    setError(pagePasswordError);
  }, [pagePasswordError]);

  const handleChange = (event) => {
    setPassword(event.target.value);
  };

  const handlePasswordVerify = (event) => {
    event.preventDefault();
    if (password && password.length > 0) {
      dispatch(verifyPagePasswordRequest({ password }));
    } else {
      setError('Password is required');
    }
    track('handlePasswordVerifed for agency search');
  };

  return (
    <div className="bg-theme h-screen">
      <Topbar />
      {!_.isEmpty(travelAgency) ? (
        <div className="flex flex-col lg:flex-row items-center py-12 text-header-0">
          <div className="flex-1" />
          <div className="flex justify-center flex-1 mb-4 lg:mb-0">
            <AgencyLogoWithAttribution />
          </div>
          <div className="flex-1 flex justify-center">
            {doShowAgentLoginOnPasswordScreen && <LoginButton />}
          </div>
        </div>
      ) : (
        <div className="max-w-7xl mx-auto py-12 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto grid grid-cols-3 mt-8">
            <div className="flex justify-self-center col-start-2 items-center">
              <TravelWitsLogo />
            </div>
          </div>
        </div>
      )}
      <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white shadow overflow-hidden rounded-3xl p-8">
            <div className="flex justify-center items-center">
              <div className="flex flex-col justify-center items-center gap-5">
                <div className="w-12 h-12 rounded-full border-2 border-gray-700 flex justify-center items-center">
                  <MdLock size={24} className="text-gray-700" />
                </div>
                <p className="text-gray-700 text-2xl sm:text-4xl font-bold">{passwordScreenHeading || 'PASSWORD PROTECTED'}</p>
                {passwordScreenDescription && <div className="text-center px-16 sm:px-64"><MarkdownToHtml content={passwordScreenDescription} className="text-gray-700 text-10" /></div>}
                <form onSubmit={handlePasswordVerify}>
                  <div className="relative flex items-center">
                    <input
                      type="password"
                      placeholder={passwordScreenInputPlaceHolder}
                      className={`border-2 ${error && 'border-red-600'} pl-2 pr-6 py-2 text-sm text-gray-700`}
                      value={password}
                      onChange={handleChange}
                      // eslint-disable-next-line jsx-a11y/no-autofocus
                      autoFocus
                      disabled={pagePasswordRequestState === SearchStatus.SEARCHING}
                    />
                    {pagePasswordRequestState === SearchStatus.SEARCHING ? (
                      <CircularProgress color="secondary" size="1rem" className="absolute right-0 mr-1" />
                    ) : (
                      <button type="submit" className="absolute right-0 pr-1" disabled={pagePasswordRequestState === SearchStatus.SEARCHING}>
                        <MdArrowForward size={22} className={`text-gray-700 ${error && 'text-red-600'}`} />
                      </button>
                    )}
                    {error && <p className="absolute left-0 mt-16 text-10 text-red-600">{error || 'Wrong password!'}</p>}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PasswordScreen.propTypes = {
  setDoShowPasswordScreen: PropTypes.func,
  doShowPasswordScreen: PropTypes.bool,
};

PasswordScreen.defaultProps = {
  setDoShowPasswordScreen: () => {},
  doShowPasswordScreen: false,
};

export default PasswordScreen;
